import React, { useMemo } from "react";
import { connect, useSelector } from "react-redux";
import MetisMenu from "react-metismenu";
import { setEnableMobileMenu } from "../../../redux/reducers/ThemeOptions";
import { AdminNav } from "./NavItems";
import withRouter from "../../../hooks/withRouter";
import { filterNavByRbac } from "../../../helpers/filterNavByRbac";
import MetisRouterLink from "./MetisRouterLink";

function Nav(props) {
  const { enableMobileMenu, setEnableMobileMenu } = props;
  const perm = useSelector((s) => s.permissions);

  const toggleMobileSidebar = () => {
    setEnableMobileMenu(!enableMobileMenu);
  };

  /**
   * One menu tree (AdminNav): after `perm.loaded`, `filterNavByRbac` keeps an item only if
   * `canReadModule` passes — i.e. `permissions[rbacModule].read === 1` when the API matrix exists
   * (including Super Admin’s full map). Parent groups stay if any child passes. `superAdminOnly`
   * still requires `isSuperAdmin`.
   */
  const navItems = useMemo(() => {
    if (perm.loaded) {
      return filterNavByRbac(AdminNav, perm);
    }
    return [];
  }, [perm]);

  return (
    <>
      <h5 className="app-sidebar__heading"></h5>
      <MetisMenu
        content={navItems}
        LinkComponent={MetisRouterLink}
        onSelected={toggleMobileSidebar}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
});

const mapDispatchToProps = (dispatch) => ({
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Nav));
